import { useEffect, useRef, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { UploadSimple, X, Spinner } from "@phosphor-icons/react";

export function ImagePicker({ onSelect, onClose }) {
  const [images, setImages] = useState(null);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const load = () => api.listImages().then(r => setImages(r.items)).catch(() => setImages([]));
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const r = await api.uploadImage(file);
      toast.success("Image uploaded");
      onSelect(r.url);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Upload failed");
      setUploading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose} data-testid="image-picker-overlay">
      <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-lg border border-zinc-200 shadow-xl w-full max-w-2xl max-h-[85vh] overflow-auto p-5">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-heading text-base font-medium">Choose an image</h3>
          <div className="flex items-center gap-2">
            <label className="inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-md bg-zinc-950 text-white hover:bg-zinc-800 cursor-pointer" data-testid="image-upload-btn">
              <input ref={fileRef} type="file" accept="image/*" onChange={upload} className="hidden" data-testid="image-upload-input"/>
              {uploading ? <Spinner size={12} className="animate-spin"/> : <UploadSimple size={12}/>} Upload new
            </label>
            <button onClick={onClose} className="text-zinc-400 hover:text-zinc-900" data-testid="image-picker-close"><X size={16}/></button>
          </div>
        </div>
        {!images ? (
          <div className="text-sm text-zinc-500 py-8 text-center">Loading…</div>
        ) : images.length === 0 ? (
          <div className="text-sm text-zinc-500 py-8 text-center">No images yet — upload your first one.</div>
        ) : (
          <div className="grid grid-cols-4 gap-3" data-testid="image-grid">
            {images.map(img => (
              <button key={img.id} onClick={() => onSelect(img.url)} data-testid={`image-item-${img.id}`}
                className="group border border-zinc-200 rounded-md overflow-hidden hover:border-zinc-950 transition-colors bg-zinc-50">
                <div className="h-24 flex items-center justify-center p-2 bg-white">
                  <img src={img.url} alt={img.filename} className="max-h-full max-w-full object-contain"/>
                </div>
                <div className="px-2 py-1 text-[10px] text-zinc-500 truncate border-t border-zinc-100">{img.filename}</div>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
